module.exports = __webpack_public_path__ + "static/media/p5.6199e817.png";